import React from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// material ui
import {
  Card,
  CardHeader,
  IconButton,
  Grid,
  Box,
  CardContent,
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton, CommonCurdPopUp } from "../../../../components";
import Notifier from "../../../../components/common/Notifier";
import ErrorNotifier from "../../../../components/common/ErrorNotifier";
// redux


import {
  updateassessmentType,
  getassessmentType,
  resetMessage,
  resetErrMessage,


} from "../../../../features/config/assessmentTypeSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  assessmentType: Yup.string().required("Question Type is required"),
  assessmentTypeCode: Yup.string().required("Code is required"),
  description: Yup.string(),
});

//   ------------------------------------------------------------------------------------------

const UpdateQuestionType = (props) => {
  const { message, errMessage, selectedData,loading } = useSelector(
    (state) => ({ ...state.assessmentTypeConfig })
  );

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      assessmentType: selectedData?.assessmentType,
      assessmentTypeCode: selectedData?.code,
      description: selectedData?.description,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const res = await dispatch(
        updateassessmentType({
          id: selectedData.id,
          assessmentType: values.assessmentType,
          code: values.assessmentTypeCode,
          description: values.description,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getassessmentType());
          }, 2000);
          return true;
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
        return false;
      });
      return res;
    },
  });

  const handleSubmit = async () => {
    const result = await formik.submitForm();
    return result;
  };
  return (
    <>

      {props?.showEdit && <CommonCurdPopUp
        heading={`Update Assessment Type`}
        mediumScreen={true}
        close={props.close}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} >
            <MyTextInput
              label="Assessment Type"
              type="text"
              name="assessmentType"
              required={true}
              fullWidth={true}
              margin="normal"
              id="assessmentType"
              value={formik.values.assessmentType}
              onChange={formik.handleChange}
              error={
                formik.touched.assessmentType &&
                Boolean(formik.errors.assessmentType)
              }
              helperText={
                formik.touched.assessmentType &&
                formik.errors.assessmentType
              }
            />
            <MyTextInput
              label="Code"
              type="text"
              name="assessmentTypeCode"
              required={true}
              fullWidth={true}
              margin="normal"
              id="assessmentTypeCode"
              value={formik.values.assessmentTypeCode}
              onChange={formik.handleChange}
              error={
                formik.touched.assessmentTypeCode &&
                Boolean(formik.errors.assessmentTypeCode)
              }
              helperText={
                formik.touched.assessmentTypeCode &&
                formik.errors.assessmentTypeCode
              }
            />

            <MyTextInput
              label="Comments"
              type="text"
              name="description"
              fullWidth={true}
              margin="normal"
              id="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={formik.touched.description && formik.errors.description}
            />
          </Grid>
          {/* <Box style={{ width: "100%", textAlign: "center" }} >

            <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
              Submit
            </FormSubmitButton>
          </Box> */}
        </Grid>

      </CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </>
  );
};

export default UpdateQuestionType;
